module.exports = __webpack_public_path__ + "img/pdf-ok-20.7671083b.png";